<template>

	<div :style="{height: height}" class="imageList">
		<ImageZoomable v-for="(image, index) in images"
		               :key="index"
		               :style="{height: height}"
		               v-bind="image">
		</ImageZoomable>
	</div>

</template>

<script>
import ImageZoomable from "./ImageZoomable";

export default {
	name: "ImageList",
	components: {ImageZoomable},
	props: ["images", "height"]
};
</script>

<style lang="scss" scoped>
.imageList {
	display: flex;
	height: 50vh;
	margin: $G-default*2 0;
	@include breakpoint(xs) {
		flex-wrap: wrap;
		height: auto;
	}

	& > div {
		flex: 1 1 20%;

		@include breakpoint(xs) {
			flex-basis: 100%;
			height: 56vw;
		}
	}

	&.full_height {
		height: 100vh;
		@include breakpoint(xs) {
			height: auto;
		}
	}

	&.large_height {
		height: 75vh;
		@include breakpoint(xs) {
			height: auto;
		}
	}

	&.auto_height {
		height: auto;
	}
}
</style>